// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.85.0-beta.3275dcf7',
  revision: '3275dcf7',
  branch: 'develop',
  date: 'Tue, 03 Feb 2026 18:11:33 GMT'
};